import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useEffect, useRef, useState } from 'react';
import { deleteDoc, doc } from 'firebase/firestore';
import db from '../Backend';

const TestimonyCommentList = ({commenterName,commentText,commentdate,timestamp,commentID}) => {
    const [showMenuoptions,setMenuOptions]=useState(false);
    const ref = useRef();
    // const [doc_id,setDocid]=useState("");

    const deleteComment=async(doc_id)=>{
        const checkOwner = sessionStorage.getItem("owner");
        if(checkOwner && checkOwner === commenterName){
            const doc_ref = doc(db,"comments",doc_id);
            await deleteDoc(doc_ref);
        }
    };

    useEffect(() => {
        ref.current?.scrollIntoView({behavior:"smooth"})
    },[commentText]);

    return ( 
    <div className="tcList flex-column1" style={{gap:"5px",width:"100%"}} ref={ref} key={timestamp}>
        <div className="flex-spacebetween" style={{width:"100%"}}>
            <div className="flex-column1">
            <p>{commenterName && commenterName}</p>
            <p>{commentdate}</p>
            </div>

            <div className="commentmenu" style={{position:"relative"}}>
                <div onClick={()=>setMenuOptions(prev => !prev)}
                style={{cursor:"pointer"}}>
                    <MoreVertIcon/>
                </div>

                {showMenuoptions && 
                    <div className="ccmenuoption flex-column2">
                    <button onClick={()=>deleteComment(commentID)}>Delete</button>
                    </div>
                }
              
            </div>
          
        </div>
        <div className="tctext" style={{width:"100%"}}>
        <pre>{commentText && commentText}</pre>
        </div>
      
    </div> 
    );
}
export default TestimonyCommentList;